import { NgModule } from '@angular/core';
import { ContactsService } from './contacts-service/contacts.service';
import { DashboardApiService } from './dashboard-api.service';
import { IntegrationsService } from './integrations-service/integrations.service';
import { InvitationsService } from './invitations-service/invitations.service';
import { EventsService } from './events-service/events.service';
import { FileService } from './file-service/file.service';
import { PublicApiClientsService } from './integrations-service/publicapiclients-service/publicapiclients.service';
import { CustomFontsService } from './customfonts-service/customfonts.service';
import { ActivityLogsService } from './activitylogs-service/activitylogs.service';
import { UsersService } from './users-service/users.service';
import { AttendeesService } from './attendees-service/attendees.service';
import { UtmTrackingsService } from './utmtrackings-service/utmtrackings.service';
import { SupportConfigsService } from './support-config-service/support-config.service';
import { ETicketService } from './e-ticket-service/e-ticket.service';
import { FrontdeskLocationsService } from './frontdesk-locations-service/frontdesk-locations.service';
import { BrandingService } from './branding-service/branding.service';
import { ReportsService } from './reports-service/reports.service';
import { GalleryService } from './gallery-service/gallery.service';
import { EventCustomFieldsService } from './eventcustomfields-service/eventcustomfields.service';
import { TextTemplatesService } from './texttemplates-service/texttemplates.service';
import { ReportQueriesService } from './reportqueries-service/reportqueries.service';
import { RegistrationTokensService } from './registrationtokens-service/registrationtokens.service';
import { NotificationsService } from './notifications-service/notifications.service';
import { NotificationSettingsService } from './notificationsettings-service/notificationsettings.service';
import { MailTrackingSettingsService } from './mailtrackingsettings-service/mailtrackingsettings.service';
import { EventTextTemplatesService } from './eventcustomfields-service copy/eventcustomfields.service';
import { DocumentsService } from './documents-service/documents.service';
import { FootersService } from './footers-service/footers.service';
import { AdvancedTemplatesService } from './advanced-templates-service/advanced-templates.service';
import { TimelinesService } from './timelines-service/timelines.service';
import { CampaignsService } from './campaigns-service/campaigns.service';
import { PromotionsService } from './promotions-service/promotions.service';
import { DomainsService } from './domains-service/domains.service';
import { SpeakersService } from './speakers-service/speakers.service';
import { WorkshopsService } from './workshops-service/workshops.service';
import { FilecenterService } from './filecenter-service/filecenter.service';
import { SignalrService } from './signalr-service/signalr.service';
import { TeamsService } from './teams-service/teams.service';
import { ProductsService } from './products-service/products.service';
import { SlugsService } from './slugs-service/slugs.service';
import { GDPRDataPrivacyService } from './gdpr-data-privacy-service/gdpr-data-privacy.service';
import { UserProvisioningsService } from './user-provisionings-service/user-provisionings.service';
import { HalitoService } from './halito-service/halito.service';

@NgModule({
  providers: [
    DashboardApiService,
    InvitationsService,
    IntegrationsService,
    ContactsService,
    TextTemplatesService,
    EventsService,
    FileService,
    PublicApiClientsService,
    CustomFontsService,
    ETicketService,
    FrontdeskLocationsService,
    ActivityLogsService,
    UsersService,
    AttendeesService,
    UtmTrackingsService,
    SupportConfigsService,
    ReportsService,
    BrandingService,
    EventCustomFieldsService,
    GalleryService,
    ReportQueriesService,
    RegistrationTokensService,
    NotificationsService,
    NotificationSettingsService,
    MailTrackingSettingsService,
    EventTextTemplatesService,
    FootersService,
    AdvancedTemplatesService,
    DocumentsService,
    TimelinesService,
    CampaignsService,
    PromotionsService,
    DomainsService,
    SpeakersService,
    WorkshopsService,
    FilecenterService,
    SignalrService,
    TeamsService,
    ProductsService,
    SlugsService,
    GDPRDataPrivacyService,
    UserProvisioningsService,
    HalitoService
  ]
})
class DashboardApiModule { }

export { DashboardApiModule };
